import React, { useState } from 'react';
import { Dumbbell } from 'lucide-react';
import { products, Product, BRANDS, getProductBrand } from '../data/products';
import { ProductCard } from './ProductCard';
import { ProductModal } from './ProductModal';
interface ProductsSectionProps {
  activeBrand?: string | null;
  onBrandFilter?: (brand: string | null) => void;
}
export function ProductsSection({
  activeBrand = null,
  onBrandFilter
}: ProductsSectionProps) {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const filteredProducts = products.filter(product => activeBrand ? getProductBrand(product) === activeBrand : true);
  const getSectionTitle = () => activeBrand ? `Productos ${activeBrand}` : 'Nuestros Productos';
  return <section className="bg-dark-900 py-[80px] px-5" id="productos" data-id="element-437" data-mp="20qvg6qwetf6e">
      <div className="max-w-[1100px] mx-auto" data-id="element-438" data-mp="3q50lk6gw1t56">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white flex items-center justify-center gap-3 transition-all duration-300" data-id="element-439" data-mp="3v2tp0rqt491r">
          <Dumbbell className="w-8 h-8 text-alphaGold" data-id="element-440" data-mp="387q4uggrkv2i" /> {getSectionTitle()}
        </h2>
        <p className="text-center text-[#aaa] mb-8 text-[1.05rem]" data-id="element-441" data-mp="339y9fcgwuqtk">
          Hacé click en cualquier producto para ver todos los detalles y hacer
          tu pedido
        </p>

        {/* Brand Tabs */}
        <div className="flex justify-center gap-2 sm:gap-4 mb-12 flex-wrap" data-id="element-442" data-mp="3d12osdai0dox">
          <button onClick={() => onBrandFilter && onBrandFilter(null)} className={`px-6 py-2.5 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider transition-all duration-300 ${!activeBrand ? 'bg-alphaGold text-dark-900 shadow-[0_0_15px_rgba(212,160,23,0.4)]' : 'bg-dark-700 text-[#aaa] hover:bg-dark-600 hover:text-white border border-dark-500'}`} data-id="element-443" data-mp="2pbhtcux5rnyr">
            Todos
          </button>
          {BRANDS.map(brand => <button key={brand} onClick={() => onBrandFilter && onBrandFilter(brand)} className={`px-6 py-2.5 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider transition-all duration-300 ${activeBrand === brand ? 'bg-alphaGold text-dark-900 shadow-[0_0_15px_rgba(212,160,23,0.4)]' : 'bg-dark-700 text-[#aaa] hover:bg-dark-600 hover:text-white border border-dark-500'}`} data-id="element-444" data-mp="9kc3kr6chu2n">
              {brand}
            </button>)}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[30px]" data-id="element-445" data-mp="2jom6thr3j2ie">
          {filteredProducts.map(product => <ProductCard key={product.id} product={product} onClick={() => setSelectedProduct(product)} data-id="element-446" data-mp="2okjnxqa6ocw8" />)}
        </div>
      </div>

      <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} data-id="element-447" data-mp="2xg985vzwb181" />
    </section>;
}